'use client';

import { useEffect, useMemo, useState } from 'react';
import classes from './styles.module.scss';
import Spinner from '@/components/Spin/Spinner';

const CarIFrameContent = ({
    iframe,
    width = '100%',
    height = '40vw',
}: {
    iframe: string | undefined;
    width: string;
    height: string;
}) => {
    // eslint-disable-next-line react/no-danger, react/no-unstable-nested-components
    const Iframe = useMemo(() => {
        const reformattedCarIframe =
            iframe && typeof iframe === 'string'
                ? iframe
                      .replace(/\\\//g, '/')
                      .replace(
                          '<iframe',
                          `<iframe class="${classes.iframe_loading}"`
                      )
                      .replace(
                          'background: url(https://360spin.glo3d.net/loader.gif)',
                          ''
                      )
                : '';
        // eslint-disable-next-line react/no-danger
        return (
            <div
                dangerouslySetInnerHTML={{ __html: reformattedCarIframe }}
                style={{ width, height }}
            />
        );
    }, [iframe, width, height]);

    const [clientLoaded, setClientLoaded] = useState(false);
    useEffect(() => {
        const processNextTick = setTimeout(() => setClientLoaded(true), 0);
        return () => {
            clearTimeout(processNextTick);
        };
    }, []);
    return clientLoaded ? <div>{Iframe}</div> : <Spinner />;
};

export default CarIFrameContent;
